import { Env } from '@/shared/config/environment';
import { HttpClient } from '@/shared/lib/http-client';

export const savePetsOrder = async (orderDraft) => {
  const response = await HttpClient.post(`${Env.server.mode}/insurance/pets/order/create`, orderDraft);

  return response.data;
};